// extracted by mini-css-extract-plugin
export default {"gif":"Loading_gif__BhI4C"};